const asArray = (value) => (Array.isArray(value) ? value : value ? [value] : []);

const getLocalizedValue = (value) => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || undefined;
  }
  if (typeof value === "number") return String(value);
  if (typeof value === "object") {
    const candidate =
      value.fr ??
      value.en ??
      value.de ??
      value.it ??
      value.label ??
      value.title ??
      value.name;

    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }

    const firstString = Object.values(value).find(
      (entry) => typeof entry === "string" && entry.trim()
    );
    return typeof firstString === "string" ? firstString.trim() : undefined;
  }
  return undefined;
};

const normalizeMethodId = (value) => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    const asNumber = Number(trimmed);
    return Number.isFinite(asNumber) ? asNumber : trimmed;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : undefined;
  }
  return undefined;
};

const normalizeAllowedMethod = (method, index) => {
  if (!method || typeof method !== "object") return null;

  const id = normalizeMethodId(
    method.id ??
      method.payment_method_configuration_id ??
      method.paymentMethodConfigurationId ??
      method.value ??
      method.key
  );
  if (id === undefined) return null;

  const label =
    getLocalizedValue(method.name) ||
    getLocalizedValue(method.label) ||
    getLocalizedValue(method.resolved_description) ||
    getLocalizedValue(method.resolvedDescription) ||
    getLocalizedValue(method.description) ||
    `payment_method_${index + 1}`;

  return {
    id,
    label,
  };
};

export const extractAllowedPaymentMethods = (transactionPayload) => {
  const rawMethods =
    transactionPayload?.allowed_payment_methods ||
    transactionPayload?.data?.allowed_payment_methods ||
    transactionPayload?.transaction_data?.allowed_payment_methods ||
    transactionPayload?.transaction_data?.data?.allowed_payment_methods ||
    [];

  const methods = asArray(rawMethods)
    .map((method, index) => normalizeAllowedMethod(method, index))
    .filter(Boolean);

  const seen = new Set();
  return methods.filter((method) => {
    const key = String(method.id);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const resolvePaymentTypeFromSelectedCard = (card) =>
  getLocalizedValue(card?.brand?.name) ||
  getLocalizedValue(card?.brand?.label) ||
  getLocalizedValue(card?.brand?.title) ||
  getLocalizedValue(card?.brand) ||
  "carte_credit_debit";
